const HistoryChanges = (changes) => {
    const createPropertyChange = propertyChange => `${propertyChange.propertyName} ${__('set to')} ${propertyChange.propertyValue}`;

    const createPropertyChanges = (changes, parentIdx) => {
        return (
            <React.Fragment key={parentIdx}>
                <li style={{fontWeight: 'bold'}}>{changes.operation}</li>
                <ul>
                    {changes.propertyChanges.map((c, idx)=> <li key={idx}>{createPropertyChange(c)}</li>)}
                </ul>
            </React.Fragment>
        )
    }

    const createMessages = (changes) => {
        var results = []
        
        changes.forEach((change, idx) => {
            if (change.propertyChanges.length === 0) {
                results.push(<li key={idx}>{change.operation}</li>)
            } else {
                results.push(createPropertyChanges(change, idx))
            }
        })

        return results
    }

    return createMessages(changes)
}

export default HistoryChanges;